import {
  PermissionType,
  SupportedAppCodes,
} from '@app/shared/types/portal/permissions/permissions.type';

/**
 * all permissions used in the app should be added here, and then can be imported from this file when needed
 */
export const PERMISSIONS = {
  PortalEvents: {
    View: {
      name: 'Events.View',
      type: PermissionType.action,
      app_code: SupportedAppCodes.XPRT,
    },
  },
  PortalSites: {
    View: {
      name: 'Sites.Items.View',
      type: PermissionType.action,
      app_code: SupportedAppCodes.XPRT,
    },
  },
};
